import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectInfiniteScrollModule } from './mat-select-infinite-scroll/mat-select-infinite-scroll.module';
import { SgAutoCompleteInputComponent } from './auto-complete-input/auto-complete-input.component';
import { SgAutoCompleteSelectComponent } from './auto-complete-select/auto-complete-select.component';
import {
  SgAutoCompleteAsyncTemplateDirective,
  SgAutoCompleteSelectOptionDirective,
  SgAutoCompleteSelectTriggerDirective,
} from './directives/auto-complete-select-option-def.directive';

@NgModule({
  declarations: [
    SgAutoCompleteSelectComponent,
    SgAutoCompleteInputComponent,
    SgAutoCompleteSelectOptionDirective,
    SgAutoCompleteSelectTriggerDirective,
    SgAutoCompleteAsyncTemplateDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectInfiniteScrollModule,
  ],
  exports: [
    SgAutoCompleteSelectComponent,
    SgAutoCompleteInputComponent,
    SgAutoCompleteSelectOptionDirective,
    SgAutoCompleteSelectTriggerDirective,
    SgAutoCompleteAsyncTemplateDirective,
  ],
})
export class SgAutoCompleteSelectModule {}
